<template>
    <div class="Introduction">
        <div class="header">
            <div class="headerText">{{$t('誉诚防护').toUpperCase()}}</div>
        </div>
        
        <div class="header2" >
            <p class="header2Title">{{$t('公司简介')}}</p>
            <transition name="fade">
                <p class="header2Text" v-show="header2">{{$t('公司简介详情')}}</p>
            </transition>    
        </div>
        <div class="map">
            <p class="header2Title">{{$t('誉诚在全球')}}</p>
            <p class="mapText mapFirtsText" v-html="$t('誉诚在全球详情')"></p>
            <div class="mapMain" ref="map">
                <Cmap v-if="mapShow"></Cmap>
            </div>
        </div>
        <div class="yuchenInWorld world1" ref="worldMainText">
            <transition name="fade">
                <p v-if="worldMainText" class="worldMainText">{{$t('50类产品，覆盖30余个国家')}}</p>
            </transition>
            <transition name="fade">
                <p v-if="worldMainText" class="worldMiniText" v-html="$t('50类产品，覆盖30余个国家详情')"></p>
            </transition>
        </div>
        <div class="yuchenInWorld world2" ref="worldMainText2">
            <transition name="fade">
                <p v-if="worldMainText2" class="worldMainText">{{$t('日产1.5万件医用防护服，产量达全省的20％以上')}}</p>
            </transition>
           <transition name="fade">
                <p v-if="worldMainText2" class="worldMiniText" v-html="$t('日产1.5万件医用防护服，产量达全省的20％以上详情')"></p>
            </transition>
            
        </div>
        <div class="culture">
            <p class="header2Title">{{$t('企业文化')}}</p>
            <el-row class="cultureFirst">
                <el-col class="culture_item" :xs="24" :sm="24" :md="{span:8,offset:4}">
                    <img src="../../public/img/culture1.jpg" width="100%" alt="" srcset="">
                </el-col>
                <el-col class="culture_item" :xs="24" :sm="24" :md="8">
                    <p class="itemTitle">{{$t('愿景')}}</p>
                    <p class="itemText">{{$t('成为行业领先的一次性无纺布用品制造商')}}</p>
                </el-col>
            </el-row>
            <el-row >
                <el-col class="culture_item" :xs="24" :sm="24" :md="{span:8,offset:4}">
                    <p class="itemTitle">{{$t('使命')}}</p>
                    <p class="itemText">{{$t('持续创新，为客户创造最大的价值')}}</p>
                </el-col>
                <el-col class="culture_item" :xs="24" :sm="24" :md="8">
                    <img src="../../public/img/culture2.jpg" width="100%" alt="" srcset="">
                </el-col>
            </el-row>
            <el-row >
                <el-col class="culture_item" :xs="24" :sm="24" :md="{span:8,offset:4}">
                    <img src="../../public/img/culture3.jpg" width="100%" alt="" srcset="">
                </el-col>
                <el-col class="culture_item" :xs="24" :sm="24" :md="8">
                    <p class="itemTitle">{{$t('价值观')}}</p>
                    <p class="itemText">{{$t('诚信为本，质量第一')}}</p>
                </el-col>
            </el-row>
        </div>
        <div class="responsibility">
            <p class="title">{{$t('社会责任')}}</p>
            <br>
            <p class="text">
                {{$t('与时间赛跑')}}
            </p>
            <br>
            <p class="text">{{$t('众人拾柴')}}</p>
            <br>
            <p class="text">{{$t('宁可废一件')}}</p>
        </div>
        <foot></foot>
    </div>
</template>
<script>
import foot from "@/components/foot.vue";
import Cmap from "@/components/map.vue";

export default {
    data() {
        return {
            header2:false,
            mapShow:false,
            worldMainText:false,
            worldMainText2:false,
            winH:0,
            timer:null,
        }
    },
    components:{
        foot,Cmap
    },
    methods:{
        listenScroll(){
            let scroll = document.documentElement.scrollTop
            if((!this.mapShow) && this.$refs.map.getBoundingClientRect().top-this.winH<0){
                this.mapShow = true
            }

            if((!this.worldMainText) && this.$refs.worldMainText.getBoundingClientRect().top-this.winH<-100){
                this.worldMainText = true
            }
            if((!this.worldMainText2) && this.$refs.worldMainText2.getBoundingClientRect().top-this.winH<-100){
                this.worldMainText2 = true
            }

        }
    },
    mounted(){
        this.header2 = true;
        this.timer = setInterval(this.listenScroll,200)
        this.winH = document.documentElement.clientHeight || document.body.clientHeight
    },
    destroyed(){
        clearInterval(this.timer)
    }
}
</script>
<style lang="less">
.Introduction{
    width: 100%;
    position: relative;
    .header{
        width: 100%;
        position: relative;
        height: 500px;
        background-image: url('../../public/img/IntroductionHeader.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        .headerText{
            position: absolute;
            left: 21%;
            top: 50%;
            transform: translate(0,-40%);
            color: #fff;
            font-weight: bold;
            font-size: 2rem;
            letter-spacing: 0.15rem;
        }
    }
    .header2{
        width: 100%;
        background: url('../../public/img/IntroductionHeader2.jpg') no-repeat;
        background-size: cover;
        background-position: center;
        padding: 1px;
        padding-top: 5rem;
        padding-bottom: 5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .header2Text{
            margin: 0.5rem auto;
            color: #737373;
            text-align: center;
            font-size: 0.6rem;
            line-height: 200%;
            letter-spacing: 0.1rem;
        }
        @media (max-width: 1024px) {
            .header2Text{
                width: 80%;
            }
        }
        @media (min-width: 1024px) {
            .header2Text{
                width: 30rem;   
            }
        }
    }
    .map{
        width: 100%;
        padding-top: 5rem;        
        .mapText{
            text-align: center;
            color: #737373;
            font-size: 0.6rem;
            line-height: 200%;            
            letter-spacing: 0.1rem;
        }
        .mapFirtsText{
            margin-top: 1.6rem;
        }
        .mapMain{
            position: relative;
            padding-bottom: 3rem;
            min-height: 50vh;
        }
    }
    .world1{
        background: url('../../public/img/IntroductionWorld.jpg') no-repeat;
    }
    .world2{
        background: url('../../public/img/IntroductionWorld2.jpg') no-repeat;
    }
    .yuchenInWorld{
        width: 100%;
        height: 35vh;
        background-size: cover;
        background-position: center;
        padding: 1px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .worldMainText{
            color: #fff;
            font-size: 1.2rem;
            text-align: center;
            font-weight: bold;
            margin-bottom: 1rem;
        }
        .worldMiniText{
            font-size: 0.7rem;
            text-align: center;
            color: #fff;
            line-height: 200%;
        }
    }
    .culture{
        padding: 1px;
        padding-bottom: 3rem;
        padding-top: 1rem;
        .cultureFirst{
            margin-top: 2.5rem;
        }
        .culture_item{
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            .itemTitle{
                color: #3A3A3A;
                margin-top: 5rem;
                font-size: 1rem;
            }
            .itemText{
                margin-top: -0.3rem;
                font-size: 0.7rem;
                width: 100%;
                text-align: center;
                color: #737373;
            }
        }
    }
    .responsibility{
        width: 100%;
        min-height: 500px;
        background: url('../../public/img/responsibility.jpg') no-repeat;
        background-size: cover;
        background-position: center;
        color: #fff;
        padding: 1px;
        padding-bottom: 5rem;
        .title{
            text-align: center;
            font-weight: bold;
            font-family: "Microsoft YaHei UI";
            margin-top: 5rem;
            font-size: 1.2rem;
        }
        .text{
            font-size: 0.7rem;
            width: 40%;
            margin: 0 auto;
            text-align: center;
            color: #fff;
            line-height: 200%;
            letter-spacing: 0.05rem;
        }
    }
    .header2Title{
        font-size: 1.2rem;
        text-align: center;
        font-weight: bold;
        font-family: "Microsoft YaHei UI";
        color: #747474;
        // margin-top: 2.5rem;
    }
    .fade-enter-active, .fade-leave-active {
        transition: all .8s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        transform: translate(0,50%);
    }
}
</style>
<i18n>
{
  "en": {
      "誉诚防护":"YUCHeng Protection",
      "公司简介":"Company Profile",
      "公司简介详情":"Xiantao Yucheng Non-woven Products Co., Ltd. is located in the beautiful Jianghan Plain, the famous non-woven town of China, Pengchang Town, Xiantao City. The company is an import and export company specializing in the production of disposable non-woven products. The products are widely used in medical and health, pharmaceuticals, hospitals, electronics, food, household, outdoor beauty and other related fields. The main products include high-end SMS, breathable film, heat-seal protective clothing, non-woven masks, hats, work clothes, laboratory clothes, etc. The company has more than 500 production personnel, a wholly-owned subsidiary-Henan Fukai Protective Products Co., Ltd., and two processing plants. Annual production of protective clothing series reached 9 million pieces, annual output of non-woven clothing series was 5 million pieces, annual production of non-woven hat series was 9 million pieces, annual production of non-woven shoe cover series was 8 million pieces, annual production of other products reached 600 Million pieces. Based on the principle of \"customer first, integrity first\", the company welcomes domestic and foreign companies and friends from all walks of life to visit, inspect and negotiate business.",
      "誉诚在全球":"Yucheng In The World",
      "誉诚在全球详情":"Yucheng Protection is headquartered in Xiantao, Hubei, China, and has a subsidiary in Zhumadian, Henan, China. <br> The foreign trade accounts for 90%, and the exports are mainly in Europe <br>(Germany, France, Britain and other places). Mainly TYPE3 / 4/5/6 of high-end protective clothing EU standard. <br> Domestic trade accounts for 10%, of which, stable, high-bass foundry accounts for 3%, and animal husbandry accounts for 7%.",
      "50类产品，覆盖30余个国家":"50 products, covering more than 30 countries",
      "50类产品，覆盖30余个国家详情":"Products include a full range of medical protective products <br> (medical protective clothing, masks, isolation clothing, shoe covers, hats, etc.)",
      "日产1.5万件医用防护服，产量达全省的20％以上":"15,000 pieces of medical protective clothing per day, with output exceeding 20% of the whole province",
      "日产1.5万件医用防护服，产量达全省的20％以上详情":"Provide \"bullet jackets\" for medical personnel fighting on the front line of fighting the \"epidemic\". <br> The epidemic in front is tight, and production is urgent in the rear. <br> 24 hours non-stop production.",
      "企业文化":"Company Culture",
      "愿景":"Vision",
      "成为行业领先的一次性无纺布用品制造商":"Become the industry's leading manufacturer of disposable nonwovens",
      "持续创新，为客户创造最大的价值":"Continuous innovation to create maximum value for customers",
      "使命":"Mission",
      "价值观":"Values",
      "诚信为本，质量第一":"Honesty, Quality First",
      "社会责任":"Social Responsibility",
      "与时间赛跑":"Running against time, Yucheng Company has made every effort to expand production and increase capacity-January 25th (New Year's Day) urgently resumed production, 4,000 units were shipped on January 30th (New Year's Day), and Nissan increased to February 8th 11,000 units, Nissan increased to 14,000 units on February 21. So far, a total of 237,370 sets of medical protective clothing have been issued from here to provide \"bullet jackets\" for medical personnel fighting in the frontline of the \"epidemic\". 4000 sets to 15,000 sets, the hard work behind the numbers. The war in the front is tight, and production is urgent in the rear. 24 hours of continuous production, the output has reached more than 20% of the province. The main factory and branch factory of Yucheng Company, 540 people fought in the production line, worked overtime to make medical protective clothing.",
      "众人拾柴":"Everyone picked up firewood and raced against time. The production process of medical protective clothing is complicated. Only by using a professional hot-air heater, the workers can seal the joints of the protective clothing, thereby blocking the penetration of viruses and reaching the standard of professional protection. A piece of medical protective clothing, which changes from fabric to ready-to-wear and leaves the factory, has nearly 20 manufacturing processes, every level is sloppy.",
      "宁可废一件":"\"It's better to scrap one than not to break it.\" Yu Cheng strictly grasps the quality and strives to secure the front line every minute."
  },
  "zh": {
       "誉诚防护":"誉诚防护",
        "公司简介":"誉诚防护",
        "公司简介详情":"仙桃市誉诚无纺布制品有限公司位于美丽的江汉平原、中国无纺布名镇仙桃市彭场镇。本公司是一家专业生产一次性无纺布制品的进出口公司，产品广泛用于医疗卫生、制药、医院、电子、食品、家居、户外美容和其他相关领域。主要产品包括高端SMS、透气膜、热封条防护服、无纺布口罩、帽子、工作服、实验服等。公司拥有生产人员达五百多人，拥有一家全资子公司——河南富凯防护制品有限公司，及两个加工厂。防护服系列年生产量达到900万件、无纺布衣服系列年生产量500万件、无纺布帽子系列年生产量900万只、无纺布鞋套系列年生产量800万只、其他产品年生产量达到600万件。公司本着“顾客第一，诚信至上”的原则，欢迎国内外企业、各界朋友前来参观、考察、洽谈业务。",
        "誉诚在全球":"誉诚在全球",
        "誉诚在全球详情":"誉诚防护总部位于中国湖北仙桃，在中国河南驻马店建有一家子公司。<br>外贸占比90％，出口以欧洲地区（德、法、英等地）为主。以高端防护服欧盟标准的TYPE3/4/5/6类型为主。<br>内贸占比10％，其中为稳健、高贝斯代工占比3％，畜牧业占比7％。",
        "50类产品，覆盖30余个国家":"50类产品，覆盖30余个国家",
        "50类产品，覆盖30余个国家详情":"产品包括全套医疗防护产品（医用防护服、口罩、隔离衣、鞋套、帽子等）<br>一次性床单、被套、枕套、浴衣等，工业防化服、实验室用防化服等",
        "日产1.5万件医用防护服，产量达全省的20％以上":"日产1.5万件医用防护服，产量达全省的20％以上",
        "日产1.5万件医用防护服，产量达全省的20％以上详情":"为战斗在抗“疫”一线的医护人员提供“防弹衣”。<br>前方战“疫”紧，后方生产急。<br>二十四小时不间断生产。",
        "企业文化":"企业文化",
        "愿景":"愿景",
        "成为行业领先的一次性无纺布用品制造商":"成为行业领先的一次性无纺布用品制造商",
        "持续创新，为客户创造最大的价值":"持续创新，为客户创造最大的价值",
        "使命":"使命",
        "价值观":"价值观",
        "诚信为本，质量第一":"诚信为本，质量第一",
        "社会责任":"社会责任",
        "与时间赛跑":"与时间赛跑，誉诚公司千方百计扩产增能——1月25日（大年初一）紧急复工生产，1月30日（大年初六）出货4000件，2月8日日产增至1.1万套，2月21日日产增至1.4万套。至今，共有237370套医疗防护服，从这里发出，为战斗在抗“疫”一线的医护人员提供“防弹衣”。4000套到1.5万套，数字背后，是辛勤的付出。前方战“疫”紧，后方生产急。二十四小时不间断生产，产量已达全省的20％以上。誉诚公司主厂、分厂，540人奋战在生产一线，加班加点赶制医疗防护服。",
        "众人拾柴":"众人拾柴，争分夺秒。医疗防护服生产工序复杂，工人只有通过专业的胶条热风机，才能对防护服的接缝处进行密封，从而阻隔病毒的穿透，达到专业防护的标准。一件医疗防护服，从布料变为成衣装箱出厂，近20道制作工序，每一关都马虎不得。",
        "宁可废一件":"“宁可废一件，不可坏一件。”誉诚严抓质量，争分夺秒保一线。"    
  }
}
</i18n>

